export const ChevronRightIcon = ({ className, style }: StyledProps) => {
  return (
    <svg
      className={className}
      style={style}
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.883 4.117 13.767 11l-6.884 6.883"
        stroke="currentColor"
        strokeWidth="2.74"
      />
    </svg>
  );
};
